export const floatFormat =  (number, fixed) => {
	return parseFloat(Number(number).toFixed(fixed))
}